import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
  mixins: [style],
})
export default class LiveLink extends IPSDialog {
  sgId = 0;

  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '直播列表';

  width = '800px';

  cancelText = '关闭';

  mounted() {
    this.getDataList();
  }

  getDataList() {
    const postParams = {
      sgId: this.sgId,
      page: this.page,
      status: 7,
      pageNum: this.pageSize,
      keywords: this.keyword,
      siteCodes: this.siteCodes,
    };
    IPSService.liveViewList({ postParams }).then((response) => {
      this.total = response.count;
      this.dataList = response.list;
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getDataList();
  }

  onPageChange(val) {
    this.page = val;
    this.getDataList();
  }

  onSelect(ptId, ptName) {
    this.$emit('result', { id: ptId, name: ptName });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getDataList();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="直播ID/直播标题"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="40" />
          <el-table-column prop="lvId" label="直播ID" width="80" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="lvName" label="直播标题" width="180px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="actTime" label="活动期间" min-width="120px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="lvTime" label="开播时间" min-width="120px" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="name"
            label="操作"
            width="120px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.lvId, scope.row.lvName)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
